export const session = {
  methods: {
    getSessionState(cbResponce, cbErr) {
      this.$store.dispatch('getSessionState')
      .then((response) => {
        console.log(response);
        if (cbResponce !== undefined) cbResponce(response)
      }).catch((err) => {
        console.log(err);
        if (cbErr !== undefined) cbErr(err)
      })
    },

    deactivateAllSessions(cbResponce, cbErr) {
      console.log('132');
      this.$store.dispatch('deactivateAllSessions')
      .then((response) => {
        console.log(response);
        if (cbResponce !== undefined) cbResponce(response)
      }).catch((err) => {
        console.log(err);
        if (cbErr !== undefined) cbErr(err)
      })
    },


  }
}